// extracted by mini-css-extract-plugin
export default {"imgbox":"SubBanner_imgbox__Lrnn8","center":"SubBanner_center__PF1Mj","head":"SubBanner_head__aNSkr","subHead":"SubBanner_subHead__abjsB"};